import React from 'react';

interface IconShadowsProps {
    width?: number | string;
    height?: number | string;
    color?: string;
}

const IconShadows: React.FC<IconShadowsProps> = ({ width = 17, height = 16, color = 'black' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            d="M8.5 1.0625C7.02901 1.0625 5.59104 1.4987 4.36795 2.31594C3.14486 3.13319 2.19158 4.29477 1.62865 5.65379C1.06572 7.01282 0.918435 8.50825 1.20541 9.95098C1.49239 11.3937 2.20074 12.719 3.2409 13.7591C4.28105 14.7993 5.60629 15.5076 7.04902 15.7946C8.49175 16.0816 9.98719 15.9343 11.3462 15.3714C12.7052 14.8084 13.8668 13.8551 14.6841 12.6321C15.5013 11.409 15.9375 9.971 15.9375 8.5C15.9375 6.52745 15.1539 4.63569 13.7591 3.24089C12.3643 1.84609 10.4726 1.0625 8.5 1.0625ZM14.875 8.5C14.872 8.84362 14.8418 9.18646 14.7847 9.52531L11.1563 5.87031L13.0316 3.995C13.6208 4.5872 14.087 5.29013 14.4034 6.0633C14.7198 6.83648 14.8801 7.66461 14.875 8.5ZM8.87719 8.12281L10.3806 6.61938L14.4713 10.7153C14.2153 11.4066 13.8415 12.0483 13.3663 12.6119L8.87719 8.12281ZM12.5959 13.3663C12.0324 13.8415 11.3907 14.2153 10.6994 14.4712L6.60344 10.3806L8.10688 8.87719L12.5959 13.3663ZM3.995 13.005L5.87032 11.1562L9.52532 14.8112C9.18576 14.8595 8.84292 14.8808 8.5 14.875C7.66276 14.8766 6.83351 14.7121 6.06023 14.3912C5.28696 14.0702 4.58501 13.599 3.995 13.005Z"
            fill={color}
        />
    </svg>
);

export default IconShadows;
